import React, { useState } from 'react';
import { Phone, Menu, X, Globe } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function Header() {
  const {
    language,
    setLanguage,
    t
  } = useLanguage();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'es' : 'en');
  };
  const navLinks = [{
    name: t.header.services,
    href: '#services'
  }, {
    name: t.header.portfolio,
    href: '#portfolio'
  }, {
    name: t.header.process,
    href: '#process'
  }, {
    name: t.header.whyUs,
    href: '#why-us'
  }, {
    name: t.header.areas,
    href: '#areas'
  }];
  return <header className="sticky top-0 z-50 w-full bg-white border-b border-gray-100 shadow-sm" data-id="element-67">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-68">
        <div className="flex justify-between items-center h-20" data-id="element-69">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center" data-id="element-70">
            <a href="#" className="flex items-center gap-2" data-id="element-71">
              <img src="https://cdn.magicpatterns.com/uploads/bxk2iYynfEy5p9ph9KhBBP/CLPAINTING.png" alt="C&L Painting Logo" className="h-16 w-auto object-contain" data-id="element-72" />
            </a>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8" data-id="element-73">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-brand-black hover:text-brand-blue font-medium transition-colors" data-id="element-74">
                {link.name}
              </a>)}
          </nav>

          {/* Desktop Actions */}
          <div className="hidden md:flex items-center space-x-6" data-id="element-75">
            <button onClick={toggleLanguage} className="flex items-center gap-2 text-sm font-semibold text-brand-black hover:text-brand-blue transition-colors px-3 py-1.5 rounded-full border border-gray-200 hover:border-brand-blue bg-gray-50" data-id="element-76">
              <Globe className="w-4 h-4" data-id="element-77" />
              {language === 'en' ? 'EN / ES' : 'ES / EN'}
            </button>
            <a href="tel:8324397965" className="flex items-center gap-2 bg-brand-red text-white px-5 py-2.5 rounded-md font-bold hover:bg-red-800 transition-colors shadow-md" data-id="element-78">
              <Phone className="w-4 h-4" data-id="element-79" />
              (832) 439-7965
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="flex md:hidden items-center space-x-4" data-id="element-80">
            <button onClick={toggleLanguage} className="flex items-center gap-1 text-xs font-bold text-brand-black px-2 py-1 rounded border border-gray-200 bg-gray-50" data-id="element-81">
              <Globe className="w-3 h-3" data-id="element-82" />
              {language.toUpperCase()}
            </button>
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-brand-black hover:text-brand-blue p-2" data-id="element-83">
              {isMobileMenuOpen ? <X className="h-6 w-6" data-id="element-84" /> : <Menu className="h-6 w-6" data-id="element-85" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden bg-white border-t border-gray-100 absolute w-full shadow-lg" data-id="element-86">
          <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-87">
            {navLinks.map(link => <a key={link.name} href={link.href} className="block px-3 py-3 text-base font-medium text-brand-black hover:bg-gray-50 hover:text-brand-blue rounded-md" onClick={() => setIsMobileMenuOpen(false)} data-id="element-88">
                {link.name}
              </a>)}
            <div className="pt-4 mt-2 border-t border-gray-100" data-id="element-89">
              <a href="tel:8324397965" className="flex items-center justify-center gap-2 w-full bg-brand-red text-white px-5 py-3 rounded-md font-bold hover:bg-red-800 transition-colors" data-id="element-90">
                <Phone className="w-5 h-5" data-id="element-91" />
                (832) 439-7965
              </a>
            </div>
          </div>
        </div>}
    </header>;
}